import { SortOrderValues } from '@/types/sort';
import { ColumnType } from '@/types/column';
import { EntityType } from '@/types/entity';

export const defaultColumnsSettings = {
  [EntityType.Asset]: {
    columnVisibility: {
      [ColumnType.Id]: false,
      [ColumnType.DragHandle]: true,
      [ColumnType.Select]: true,
      [ColumnType.Thumbnail]: true,
      [ColumnType.Name]: true,
      [ColumnType.ParentFolderName]: true,
      [ColumnType.Type]: true,
      [ColumnType.Format]: true,
      [ColumnType.Size]: true,
      [ColumnType.Dimensions]: true,
      [ColumnType.FileName]: true,
      [ColumnType.NodeId]: true,
      [ColumnType.Slug]: true,
      [ColumnType.Description]: true,
      [ColumnType.Rating]: true,
    },
    columnOrder: [
      ColumnType.DragHandle,
      ColumnType.Select,
      ColumnType.Thumbnail,
      ColumnType.Name,
      ColumnType.ParentFolderName,
      ColumnType.Type,
      ColumnType.Format,
      ColumnType.Size,
      ColumnType.Dimensions,
      ColumnType.FileName,
      ColumnType.NodeId,
      ColumnType.Slug,
      ColumnType.Rating,
      ColumnType.Description,
    ],
  },
  [EntityType.Duplicate]: {
    columnVisibility: {
      [ColumnType.Id]: true,
      [ColumnType.Checksum]: false,
      [ColumnType.Select]: true,
      [ColumnType.Thumbnail]: true,
      [ColumnType.Name]: true,
      [ColumnType.Type]: true,
      [ColumnType.Slug]: true,
      [ColumnType.Rating]: true,
    },
    columnOrder: [
      ColumnType.Select,
      ColumnType.Thumbnail,
      ColumnType.Name,
      ColumnType.Slug,
      ColumnType.Type,
      ColumnType.Dimensions,
      ColumnType.Size,
      ColumnType.Format,
      ColumnType.Rating,
    ],
  },

  [EntityType.NodeShare]: {
    columnVisibility: {
      [ColumnType.Id]: false,
      [ColumnType.Select]: true,
      [ColumnType.Thumbnail]: true,
      [ColumnType.Name]: true,
      [ColumnType.Type]: true,
      [ColumnType.Slug]: true,
      [ColumnType.Rating]: true,
    },
    columnOrder: [
      ColumnType.Select,
      ColumnType.Thumbnail,
      ColumnType.Name,
      ColumnType.Type,
      ColumnType.Slug,
      ColumnType.Rating,
    ],
  },
  [EntityType.Share]: {
    columnVisibility: {
      [ColumnType.Id]: false,
      [ColumnType.Select]: true,
      [ColumnType.Thumbnail]: true,
      [ColumnType.Name]: true,
      [ColumnType.Type]: true,
      [ColumnType.ParentFolderName]: true,
      [ColumnType.Count]: true,
    },
    columnOrder: [
      ColumnType.Select,
      ColumnType.Thumbnail,
      ColumnType.Name,
      ColumnType.Type,
      ColumnType.ParentFolderName,
      ColumnType.Count,
    ],
  },
  [EntityType.User]: {
    columnVisibility: {
      [ColumnType.Id]: true,
      [ColumnType.UserId]: false,
      [ColumnType.Name]: true,
      [ColumnType.Profile]: true,
      [ColumnType.Role]: true,
    },
    columnOrder: [ColumnType.Id, ColumnType.UserId, ColumnType.Name, ColumnType.Profile, ColumnType.Role],
  },
  [EntityType.Invitation]: {
    columnVisibility: {
      [ColumnType.Id]: true,
      [ColumnType.Invitee]: true,
      [ColumnType.Roles]: true,
      [ColumnType.ExpiresAt]: true,
    },
    columnOrder: [ColumnType.Id, ColumnType.Invitee, ColumnType.Roles, ColumnType.ExpiresAt],
  },
  [EntityType.Tag]: {
    columnVisibility: {
      [ColumnType.Id]: true,
      [ColumnType.Name]: true,
      [ColumnType.ParentTag]: true,
      [ColumnType.Facet]: true,
      [ColumnType.Searchable]: true,
      [ColumnType.Public]: true,
      [ColumnType.CreatedBy]: true,
    },
    columnOrder: [
      ColumnType.Id,
      ColumnType.Name,
      ColumnType.ParentTag,
      ColumnType.Facet,
      ColumnType.Searchable,
      ColumnType.Public,
      ColumnType.CreatedBy,
    ],
  },
  [EntityType.Workflow]: {
    columnVisibility: {
      [ColumnType.Id]: true,
      [ColumnType.Name]: true,
      [ColumnType.Statuses]: true,
    },
    columnOrder: [ColumnType.Id, ColumnType.Name, ColumnType.Statuses],
  },
  [EntityType.Metadata]: {
    columnVisibility: {
      [ColumnType.Id]: true,
      [ColumnType.Name]: true,
      [ColumnType.Type]: true,
      [ColumnType.Facet]: true,
      [ColumnType.Searchable]: true,
      [ColumnType.Public]: true,
    },
    columnOrder: [
      ColumnType.Id,
      ColumnType.Name,
      ColumnType.Type,
      ColumnType.Facet,
      ColumnType.Searchable,
      ColumnType.Public,
    ],
  },
  [EntityType.Variant]: {
    columnVisibility: {
      [ColumnType.Id]: true,
      [ColumnType.Name]: true,
      [ColumnType.Slug]: true,
      [ColumnType.Description]: true,
      [ColumnType.FileType]: true,
      [ColumnType.Automatic]: true,
      [ColumnType.Watermark]: true,
    },
    columnOrder: [
      ColumnType.Id,
      ColumnType.Name,
      ColumnType.Slug,
      ColumnType.Description,
      ColumnType.FileType,
      ColumnType.Automatic,
      ColumnType.Watermark,
    ],
  },
  [EntityType.Destination]: {
    columnVisibility: {
      [ColumnType.Id]: true,
      [ColumnType.Name]: true,
      [ColumnType.Slug]: true,
      [ColumnType.Description]: true,
    },
    columnOrder: [ColumnType.Id, ColumnType.Name, ColumnType.Slug, ColumnType.Description],
  },
  [EntityType.Trash]: {
    columnVisibility: {
      [ColumnType.Id]: false,
      [ColumnType.Select]: true,
      [ColumnType.Thumbnail]: true,
      [ColumnType.Name]: true,
      [ColumnType.Type]: true,
      [ColumnType.Dimensions]: true,
      [ColumnType.Rating]: true,
      [ColumnType.Slug]: false,
    },
    columnOrder: [
      ColumnType.Id,
      ColumnType.Select,
      ColumnType.Thumbnail,
      ColumnType.Name,
      ColumnType.Type,
      ColumnType.Dimensions,
      ColumnType.Rating,
    ],
  },
  [EntityType.Ingestion]: {
    columnVisibility: {
      [ColumnType.Id]: false,
      [ColumnType.Path]: false,
      [ColumnType.Select]: true,
      [ColumnType.Thumbnail]: true,
      [ColumnType.Name]: true,
      [ColumnType.Type]: true,
      [ColumnType.FileName]: true,
      [ColumnType.Size]: true,
      [ColumnType.Dimensions]: true,
      [ColumnType.Progress]: true,
    },
    columnOrder: [
      ColumnType.Path,
      ColumnType.Select,
      ColumnType.Thumbnail,
      ColumnType.Name,
      ColumnType.Type,
      ColumnType.FileName,
      ColumnType.Size,
      ColumnType.Dimensions,
      ColumnType.Progress,
    ],
  },
};

export const defaultSortSettings = {
  [EntityType.Asset]: SortOrderValues.CREATED_AT,
  [EntityType.Duplicate]: SortOrderValues.CREATED_AT,
  [EntityType.NodeShare]: SortOrderValues.CREATED_AT,
  [EntityType.Share]: SortOrderValues.NAME,
  [EntityType.User]: SortOrderValues.CREATED_AT,
  [EntityType.Invitation]: SortOrderValues.CREATED_AT,
  [EntityType.Tag]: SortOrderValues.CREATED_AT,
  [EntityType.Workflow]: SortOrderValues.CREATED_AT,
  [EntityType.Metadata]: SortOrderValues.CREATED_AT,
  [EntityType.Variant]: SortOrderValues.CREATED_AT,
  [EntityType.Destination]: SortOrderValues.CREATED_AT,
  [EntityType.Trash]: SortOrderValues.CREATED_AT,
  [EntityType.Ingestion]: SortOrderValues.CREATED_AT,
};
